<template>
  <v-card>
    <v-layout>
      <v-flex xs3 style="padding-top: 0;padding-bottom: 0;">
        <img :src="user.avatar_url + '&s=200'" class="v-responsive"/>
      </v-flex>
      <v-flex xs9 mr-4>
        <div class="headline">
          <strong>{{user.first_name}} {{user.last_name}}</strong>
        </div>
        {{user.email}}<br>
        {{user.company_name}}<br>
        <br>
        Last Login: {{user.login_at | moment('MM/DD/YYYY [at] h:mm A [PT]z')}}.<br>
        <template v-if="user.last_ordered_at">
          Last Order: {{user.last_ordered_at | moment('MM/DD/YYYY [at] h:mm A [PT]z')}}<br>
        </template>
        Total Order(s): {{user.number_of_orders}}<br>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<style scoped lang="sass">
  .name
    font-size: 25px
    font-weight: 600
</style>

<script>
  export default {
    computed: {
      user () {
        return this.$store.state.user
      }
    }
  }
</script>



// WEBPACK FOOTER //
// user-summary.vue?433c3842